<template>
    <modal
        name="merge-session-confirm"
        :classes="'customModal'"
        :scrollable="true"
        :reset="true"
        :adaptive="false"
        :width="600"
        height="auto"
        @before-open="getData"
    >
        <div class="modalWrapper">
            <div class="row">
                <div class="col-md-12 mt-4 mt-md-0">
                    <div class="content__box">
                        <div class="content__box__header pb-2">
                            <p class="txt--ss">Confirm your Merge</p>
                        </div>
                        <div class="content__divider"></div>
                        <div class="content__box__body pt-0">
                            <div class="form__group mb-3 mt-3">
                                <label class="txt--xs txt--off-white">Select Session Type</label>
                                <select v-model="session_type" class="textInputField" v-if="session_type_options.length > 0" :disabled="session_type_options_disabled">
                                    <option value="" selected>Select Session Type</option>
                                    <option v-for="(type , index) in session_type_options" :key="index" :value="type">{{ type.charAt(0).toUpperCase() + type.slice(1) }}</option>
                                </select>
                            </div>
                            <div class="form__group mb-3 mt-3">
                                <label for="" class="txt--xs txt--off-white">Session Starts From</label>
                                <select v-model="start_from_id" class="textInputField" v-if="start_from_options.length > 0" :disabled="start_from_options_disabled">
                                    <option value="" selected>Select Session Start From Time</option>
                                    <option v-for="(start , index) in start_from_options" :key="index" :value="start.id">{{ start.start_from }}</option>
                                </select>
                            </div>
                            <div class="form__group mb-3 mt-3">
                                <label for="" class="txt--xs txt--off-white">Session Ends At</label>
                                <select v-model="end_from_id" class="textInputField" v-if="end_from_options.length > 0" :disabled="end_from_options_disabled">
                                    <option value="" selected>Select Session End At Time</option>
                                    <option v-for="(end , index) in end_from_options" :key="index" :value="end.id">{{ end.end_from }}</option>
                                </select>
                            </div>
                            <div class="form__group mb-3 mt-3">
                                <label for="" class="txt--xs txt--off-white">Select license</label>
                                <select v-model="selected_license" class="textInputField" v-if="license_options.length > 0" :disabled="license_options_disabled">
                                    <option value="" selected>Select License</option>
                                    <option v-for="(license , index) in license_options" :key="index" :value="license">{{ license }}</option>
                                </select>
                            </div>
                            <div class="form__group mb-3 mt-3">
                                <app-toggle
                                    :checked="paid"
                                    label="Payment Completed"
                                    @update:checked="getChecked($event, 'paid_update')"
                                    v-tooltip="'If the session is paid, please toggle this on. This will mark the merged session as paid and will not trigger a payment request to the user if the session is merged successfully.'"
                                ></app-toggle>
                            </div>

                            <div class="form__group">
                                <div class="d-flex justify-content-center flex-wrap">
                                    <ButtonWithSpinner
                                        class="button button--primary button--sm mr-3"
                                        :loading="button.loading"
                                        :success="button.success"
                                        :disabled="button.disabled"
                                        @click="mergeSessions"
                                    >Merge</ButtonWithSpinner>
                                <button
                                    type="button"
                                    @click="closeModal()"
                                    class="button button--outline button--sm"
                                >Cancel</button>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="session__modal__close" @click="closeModal()">
                <i class="fas fa-times"></i>
            </div>
        </div>
    </modal>
</template>
<script>
import Toggle from "@/components/toggle";
import ButtonWithSpinner from "@/components/Button";
export default {
    components: {
        AppToggle: Toggle,
        ButtonWithSpinner
    },
    data() {
        return {
            session_type: '',
            session_type_options: [],
            session_type_options_disabled: false,
            session_id_1: '',
            session_id_2: '',
            start_from_options_disabled: false,
            start_from_options: [],
            start_from_id: '',
            end_from_options_disabled: false,
            end_from_options: [],
            end_from_id: '',
            selected_license: '',
            license_options: [],
            license_options_disabled: false,
            paid: false,
            button: {
                loading: false,
                success: false,
                disabled: false,
            }
        }
    },
    created() {

    },
    methods: {
        resetData() {
            this.session_type = '';
            this.session_type_options = [];
            this.session_type_options_disabled = false;
            this.session_id_1 = '';
            this.session_id_2 = '';
            this.start_from_options_disabled = false;
            this.start_from_options = [];
            this.start_from_id = '';
            this.end_from_options_disabled = false;
            this.end_from_options = [];
            this.end_from_id = '';
            this.selected_license = '';
            this.license_options = [];
            this.license_options_disabled = false;
            this.paid = false;
        },
        getValueIfOnlyOption(options, defaultValue = '') {
            const filteredOptions = options.filter(o => o !== '');

            if (filteredOptions.length === 1) {
                return filteredOptions[0];
            }

            return defaultValue;
        },
        autoSelect() {
            this.session_type = this.getValueIfOnlyOption(this.session_type_options);            
            this.start_from_id = this.start_from_options ? this.start_from_options[0]['id'] : '';
            this.end_from_id = this.end_from_options.length === 2 ? this.end_from_options[1]['id'] : '';
            this.selected_license = this.getValueIfOnlyOption(this.license_options);
            this.paid = false;

            if (this.session_type !== '') {
                this.session_type_options_disabled = true;
            }

            if (this.selected_license !== '') {
                this.license_options_disabled = true;
            }
        },
        getData(e) {
            this.resetData();
            let merge_candidates = e.params.merge_candidates;
            let mapped_plates = merge_candidates.map(val => {
                return (val['correct_license'] || val['license'] || '').toUpperCase();
            });
            this.session_id_1 = merge_candidates[0].booking_id;
            this.session_id_2 = merge_candidates[1].booking_id;
            this.session_type_options = merge_candidates.map(val => val['booking_type']);
            this.session_type_options = [...new Set(this.session_type_options)];
            this.license_options = [...new Set(mapped_plates)];
            this.start_from_options = merge_candidates.map(val=> {
                return {
                    'id':val['booking_id'],
                    'start_from': val['booking_start_time']
                }
            });

            this.end_from_options = merge_candidates.filter(val => {
                if(val['booking_end_time']!='') {
                    return val;
                }
            }).map(val => {
                if(val['booking_end_time']!='') {
                    return {
                        'id': val['booking_id'],
                        'end_from': val['booking_end_time']
                    }
                } 
            });
            
            this.autoSelect();
        },
        getChecked(checked,type) {
            if(type == 'paid_update') { 
                this.paid = checked;
            }
        },
        closeModal() {
            this.$modal.hide('merge-session-confirm');
        },
        mergeSessions() {
            if(this.session_type == '' || this.session_type_options.indexOf(this.session_type) == -1) {
                this.$toasted.show("Please select a session type!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            } 

            if(this.start_from_id == '') {
                this.$toasted.show("Please select the time at which the session starts!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }

            if(this.selected_license == '') {
                this.$toasted.show("Please provide a license!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }
            
            this.button.loading = true;
            this.button.success = false;
            this.button.disabled = true;
            this.axios.post(window.hostname+ '/api/auth/merge/all/sessions',{
                session_id_1: this.session_id_1,
                session_id_2: this.session_id_2,
                license: this.selected_license,
                start_from: this.start_from_id,
                end_from: this.end_from_id,
                session_type: this.session_type,
                paid: this.paid ? 1 : 0
            })
            .then(res=> {
                if(res.data.status) {
                    this.$toasted.show(res.data.message,{
                        icon: 'check-circle',
                        className: 'success-class'
                    });
                    this.button.success = true;

                    this.$emit("merge_success");
                }
                else {
                    this.$toasted.show(res.data.message,{
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                }
                this.button.disabled = false;
                this.button.loading = false;

                this.closeModal();
            })
            .catch(err=> {
                this.$toasted.show(err.response.data.message,{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                this.button.disabled = false;
                this.button.loading  = false;
                this.button.success  = false;
            });
        }
    }
}
</script>